<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.newMember.newMember") }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex md:flex-row flex-col justify-center lg:ml-6 lg:justify-start">
            <div class="max-w-lg w-full md:w-56 lg:max-w-xs">
              <div class="relative text-gray-400 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center">
                  <SearchIcon class="h-5 w-5" aria-hidden="true" />
                </div>
                <input id="search" v-model="searchInput" maxlength="10"
                  class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  type="search" name="search" :placeholder="$t('messages.newMember.search')"
                  @input="searchText($event)" />
              </div>
            </div>
            <div class="max-w-lg w-full md:w-64 lg:max-w-xs mx-auto md:mx-0">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.newMember.from") }}
                  :
                </div>
                <input id="from" v-model="searchDate.from" maxlength="10" @change="search($event)"
                  class="block w-full bg-white py-2 pl-16 md:pl-16 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="From" type="date" name="from" />
              </div>
            </div>
            <div class="max-w-lg w-full md:w-64 lg:max-w-xs mx-auto md:mx-0">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.newMember.to") }}:
                </div>
                <input id="to" v-model="searchDate.to" maxlength="10" @change="search($event)"
                  class="block w-full bg-white py-2 pl-16 md:pl-12 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="To" type="date" name="to" />
              </div>
            </div>
            <!-- <div class="flex w-full px-5">
              <div class="flex md:flex-row flex-col row w-full xs:justify-center md:justify-start relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none inset-y-0 pl-1 left-0 flex items-center">
                  From:
                </div>
                <div class="w-full">
                  <div>
                    <input id="from" v-model="searchDate.from" maxlength="10" @change="search($event)"
                      class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-md"
                      placeholder="From" type="date" name="from" />
                  </div>
                </div>
                <div class="pointer-events-none inset-y-0 pl-1 left-0 flex items-center">
                  to:
                </div>
                <div>
                  <div class="w-full">
                    <input id="to" v-model="searchDate.to" maxlength="10" @change="search($event)"
                      class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-md"
                      placeholder="From" type="date" name="from" />
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div> -->

    <div class="relative py-6">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    @click="sort('username')">
                    {{ $t("messages.newMember.username") }}

                    <font-awesome-icon v-if="sortBy.toLowerCase() == 'username'" transform="shrink-2" class="" :icon="[
                      'fas',
                      sortDirection === 'DESC' ? 'arrow-down' : 'arrow-up',
                    ]" />
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
                    @click="sort('count')">
                    # {{ $t("messages.newMember.register") }}
                    <font-awesome-icon v-if="sortBy.toLowerCase() == 'count'" transform="shrink-2" class="" :icon="[
                      'fas',
                      sortDirection === 'DESC' ? 'arrow-down' : 'arrow-up',
                    ]" />
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
                    @click="sort('today_register_topup')">
                    {{ $t("messages.newMember.topup") }}
                    <font-awesome-icon v-if="sortBy.toLowerCase() == 'today_register_topup'" transform="shrink-2"
                      class="" :icon="[
                        'fas',
                        sortDirection === 'DESC' ? 'arrow-down' : 'arrow-up',
                      ]" />
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.newMember.todayFirstTopup") }}
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.newMember.noTopup") }}
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.newMember.downlineTopup") }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="dataRows.data && dataRows.data.length > 0" class="bg-white divide-y divide-gray-200">
                <tr @click="viewData(data)" @contextmenu="(e) => onAuxClick(e, data)" v-for="(data, i) in dataRows.data"
                  :key="i" class="hover:bg-gray-50 cursor-pointer">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.username || "ไม่มีพันธมิตร" }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ data.count }} คน
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="{ color: 'green' }">
                    {{ data.today_register_topup }} คน
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="{ color: 'blue' }">
                    {{ data.today_first_topup }} คน
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="{ color: 'red' }">
                    {{ data.no_topup }} คน
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ data.downline_topup }} คน
                  </td>
                </tr>
              </tbody>
              <tfoot class="bg-gray-100 font-bold">
                <tr>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                    {{ $t("messages.newMember.total") }}:{{
                      dataRows.totalHeadline
                    }}
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalDownline }} คน
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalTopup }} คน
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalTodayFirstTopup }} คน
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalNoTopup }} คน
                  </td>

                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalDownlineTopup }} คน
                  </td>
                </tr>
              </tfoot>
            </table>
            <Pagination v-model:config="pageConfig" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
} from "@heroicons/vue/solid";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import { watch } from "vue";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import Pagination from "@/components/tools/Pagination.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "New Member", href: "", current: true }];
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  isEmitOnClick: true,
  sort: [["created_at", "DESC"]],
});

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Pagination,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const searchDate = ref({
      from: route.query.from || new Date().toISOString().split("T")[0],
      to: route.query.to || new Date().toISOString().split("T")[0],
    });
    const searchInput = ref("");
    let dataRows = ref({
      totalHeadline: 0,
      totalDownline: 0,
      data: [],
    });
    let dataCount = ref(0);
    let isLoaded = ref(false);
    let currentDate = ref(
      route.query.date || new Date().toISOString().split("T")[0]
    );
    const sortBy = ref("count");
    const sortDirection = ref("DESC");

    onMounted(() => {
      const shrink = searchDate.value.from.split("-");
      shrink[2] = "01";
      const combine = shrink.join("-");
      refetch();
    });

    const onAuxClick = (e, data) => {
      e.preventDefault();
      window.open(
        `new-member/${data.id}?from=${searchDate.value.from}&to=${searchDate.value.to}`
      );
      return false;
    };

    const refetch = () => {
      // console.log({ from, to })
      isLoaded.value = false;
      const from = searchDate.value.from;
      const to = searchDate.value.to;
      const { page, rowsPerPage } = pageConfig.value;
      const offset = (page - 1) * rowsPerPage;
      const limit = rowsPerPage;
      const searchText = searchInput.value;
      axios
        .get(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/customers/affiliate/${store.state.selectedOperator.operatorId}/count/${from}/${to}/`,
          {
            params: {
              sort_col: sortBy.value,
              sort_method: sortDirection.value,
              offset: offset,
              limit: limit,
              search: searchText,
            },
          }
        )
        .then(({ data }) => {
          if (data.length == 0) {
            pageConfig.value.page = page > 1 ? page - 1 : 1;
          }
          build(data);
        })
        .catch(({ response }) => {
          alert("ไม่มีข้อมูล");
          isLoaded.value = true;
        });
    };

    const sort = (field) => {
      sortBy.value = field;
      sortDirection.value = sortDirection.value === "DESC" ? "ASC" : "DESC";
      refetch();
    };

    const build = (rawData) => {
      let headline = [];
      let rows = [];
      let totalDownline = 0;
      let totalTopup = 0;
      let totalTodayFirstTopup = 0;
      let totalNoTopup = 0;
      let totalDownlineTopup = 0;

      for (let i = 0; i < rawData.length; i++) {
        const row = rawData[i];

        if (!headline.includes(row.referralUserId)) {
          headline.push(row.referralUserId);
          totalTopup += Number(row.today_register_topup);
          totalTodayFirstTopup += Number(row.today_first_topup);
          totalDownline += parseFloat(row.count);
          totalNoTopup += Number(row.count - row.today_register_topup);
          totalDownlineTopup += Number(row.downline_topup);
          rows.push({
            id: row.referralUserId,
            username: row.username,
            count: row.count,
            today_register_topup: row.today_register_topup,
            today_first_topup: row.today_first_topup,
            no_topup: row.count - row.today_register_topup,
            downline_topup: row.downline_topup,
          });
        }
      }

      let build = {
        totalHeadline: headline.length,
        totalDownline: totalDownline,
        totalTopup: totalTopup,
        totalTodayFirstTopup: totalTodayFirstTopup,
        totalNoTopup: totalNoTopup,
        totalDownlineTopup: totalDownlineTopup,
        data: rows,
      };

      dataRows.value = build;
      dataCount.value = 0;
      isLoaded.value = true;
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    const search = () => {
      router.push({
        query: {
          from: searchDate.value.from,
          to: searchDate.value.to,
        },
      });
      refetch();
    };

    const searchText = (e) => {
      if (
        // (e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13) &&
        searchInput.value.length >= 3 ||
        searchInput.value.length == 0
      ) {
        isLoaded.value = false;
        // console.log(searchInput.value)
        refetch();
      } else if (searchInput.value.length == 0) {
        refetch();
      }
    };

    const runPaymentReport = () => {
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/cms/payments/manual", {
          start_date: "2021-08-01",
          end_date: "2021-08-31",
        })
        .then(({ data }) => {
          if (data.result.data.length == 1) {
            router.push({
              name: "Wallet Info",
              params: { id: data.result.data[0].id },
            });
            return;
          }

          dataRows.value = data.result.data;
          dataCount.value = data.result.count;
          isLoaded.value = true;
        })
        .catch((err) => {
          console.log(err);
          isLoaded.value = true;
        });
    };

    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const viewData = (data) => {
      router.push({
        name: "Affiliate Show",
        params: { id: data.id || "all" },
        query: { from: searchDate.value.from, to: searchDate.value.to },
      });
    };

    watch(
      () => pageConfig.value.page,
      () => refetch()
    );
    /** fetch data when rows per page was changed */
    watch(
      () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = 1;
        refetch();
      }
    );

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      searchInput,
      route,
      store,
      prev,
      next,
      search,
      viewData,
      runPaymentReport,
      pages,
      getLocaleDate,
      currentDate,
      searchDate,
      sort,
      pageConfig,
      searchText,
      sortDirection,
      sortBy,
      onAuxClick,
    };
  },
};
</script>
